/**
 * * Combine all reducers in this file and export the combined reducers.
 */

 import { combineReducers } from "@reduxjs/toolkit";
 import { InjectedReducersType } from "../utils/types/injector-typings";
 
 import { reducer as searchResults } from "../app/pages/Search/slice";
 import { reducer as dataCoverage } from "../app/pages/DataCoverage/pages/slice";
 import { reducer as otherKindCodes } from "../app/pages/DocumentView/slice";
 import { reducer as app } from "../app/slice";
 
 /**
  * Merges the main reducer with the router state and dynamically injected reducers
  */
 export function createReducer(injectedReducers: InjectedReducersType = {}) {
   return combineReducers({
    searchResults,
    dataCoverage,
    otherKindCodes,
    app,
     ...injectedReducers,
   });
 }
 